import { COMPONENTS } from '../components';
import { PhantomComponentsConfig } from '../models';

export const DEFAULT_PHANTOM_COMPONENTS_CONFIG: PhantomComponentsConfig = {
  components: {
    addToCart: {
      component: COMPONENTS.SMART.AddToCartOnProductPage
    },
    classBinder: {
      component: COMPONENTS.SMART.ClassBinder
    },
    open: {
      component: COMPONENTS.SMART.Open
    },
    scroll: {
      component: COMPONENTS.SMART.Scroll
    },
    windowEventBinder: {
      component: COMPONENTS.SMART.WindowEventBinder
    }
  }
};
